// @flow

import React from 'react';
import { colors } from 'seedling/constants';

import type { Node } from 'react';

const LockIcon = ({
  color,
  size,
}: {
  color?: string,
  size?: ?number,
}): Node => {
  return (
    <svg
      width={size}
      height={size}
      version="1.1"
      viewBox={`0 0 20 20`}
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>Lock</title>
      <path
        fill={color}
        d="M15.5517241,16.0570439 L15.5517241,8.12078564 L4.44827586,8.12078564 L4.44827586,16.0570439 L15.5517241,16.0570439 Z M5.67647059,6.67782959 L5.67647059,6.4435141 C5.67647059,4.24716984 7.62826383,2.5 10,2.5 C12.3709183,2.5 14.3235294,4.24749957 14.3235294,6.4435141 L14.3235294,6.67782959 L16.2758621,6.67782959 C16.6757924,6.67782959 17,7.0008463 17,7.39930761 L17,16.778522 C17,17.1769833 16.6757924,17.5 16.2758621,17.5 L3.72413793,17.5 C3.32420759,17.5 3,17.1769833 3,16.778522 L3,7.39930761 C3,7.0008463 3.32420759,6.67782959 3.72413793,6.67782959 L5.67647059,6.67782959 Z M7.12474645,6.67782959 L12.8752535,6.67782959 L12.8752535,6.4435141 C12.8752535,5.0809945 11.6036387,3.94295606 10,3.94295606 C8.39560838,3.94295606 7.12474645,5.08058252 7.12474645,6.4435141 L7.12474645,6.67782959 Z M10.7241379,12.6261397 L10.7241379,13.7099843 C10.7241379,14.1084457 10.3999303,14.4314624 10,14.4314624 C9.60006966,14.4314624 9.27586207,14.1084457 9.27586207,13.7099843 L9.27586207,12.6261397 C8.80840738,12.3707313 8.49137931,11.8757928 8.49137931,11.3073136 C8.49137931,10.4774084 9.16703518,9.80423437 10,9.80423437 C10.8329648,9.80423437 11.5086207,10.4774084 11.5086207,11.3073136 C11.5086207,11.8757928 11.1915926,12.3707313 10.7241379,12.6261397 Z"
      />
    </svg>
  );
};

LockIcon.defaultProps = {
  size: 20,
  color: colors.mediumGrey,
};

export default LockIcon;
